import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const slides = [
  {
    comicId: "xingyu-shaonian",
    title: "星域少年",
    subtitle: "热血 · 科幻 · 冒险",
    desc: "少年星瞳意外获得神秘星核，踏上穿越星域的冒险旅程，在浩瀚宇宙中对抗暗物质军团。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20sci%20fi%20space%20scene%20with%20a%20glowing%20nebula%20and%20distant%20floating%20space%20station%2C%20warm%20orange%20and%20deep%20navy%20gradient%20sky%2C%20cinematic%20stylized%20artistic%20illustration%20with%20strong%20contrast%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=hero-comic-01&orientation=landscape",
    accent: "bg-primary-500 hover:bg-primary-600",
  },
  {
    comicId: "jianqi-canglan",
    title: "剑起苍澜",
    subtitle: "玄幻 · 热血 · 冒险",
    desc: "苍澜大陆灵气复苏，少年叶无双一把锈剑走天下，问的不仅是武道之巅，更是千年天道之问。",
    image:
      "https://readdy.ai/api/search-image?query=Majestic%20misty%20mountains%20of%20an%20ancient%20eastern%20fantasy%20world%20with%20swirling%20ink%20clouds%20and%20glowing%20runes%2C%20warm%20amber%20and%20jade%20green%20tone%2C%20cinematic%20stylized%20artistic%20painting%20with%20strong%20contrast%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=hero-comic-02&orientation=landscape",
    accent: "bg-accent-500 hover:bg-accent-600",
  },
  {
    comicId: "xindong-xinhao",
    title: "心动信号",
    subtitle: "恋爱 · 治愈 · 校园",
    desc: "深夜广播里总有一个匿名听众点同一首歌。当主播放苏澄找到那个人时，才发现对方一直在最近的地方。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20sunset%20school%20rooftop%20with%20floating%20petals%20and%20soft%20bokeh%20lights%2C%20peach%20and%20cream%20pastel%20tone%2C%20dreamy%20stylized%20artistic%20illustration%20with%20strong%20contrast%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=hero-comic-03&orientation=landscape",
    accent: "bg-secondary-500 hover:bg-secondary-600",
  },
  {
    comicId: "anye-zhentan",
    title: "暗夜侦探",
    subtitle: "悬疑 · 都市 · 热血",
    desc: "私家侦探陆沉接手的每桩委托背后都连着同一个组织，而真相藏在他记忆深处那段空白里。",
    image:
      "https://readdy.ai/api/search-image?query=Rainy%20neon%20city%20street%20at%20night%20with%20reflections%20and%20a%20lone%20figure%20in%20a%20long%20coat%2C%20moody%20amber%20and%20charcoal%20tone%2C%20cinematic%20stylized%20noir%20illustration%20with%20strong%20contrast%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=hero-comic-04&orientation=landscape",
    accent: "bg-primary-500 hover:bg-primary-600",
  },
];

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const slide = slides[current];

  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[460px] w-full md:h-[580px]">
        {slides.map((s, idx) => (
          <div
            key={s.comicId}
            className={`absolute inset-0 transition-opacity duration-700 ${
              idx === current ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={s.image}
              alt={`${s.title} 精选推荐漫画`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/45 to-transparent"></div>
          </div>
        ))}

        <div className="relative z-10 mx-auto flex h-full max-w-6xl flex-col justify-center px-4 md:px-8">
          <span className="mb-3 inline-flex w-fit items-center gap-2 rounded-full bg-accent-500/90 px-3 py-1 text-xs text-foreground-950">
            <i className="ri-fire-line"></i>
            精选推荐
          </span>
          <h2 className="font-heading text-3xl text-background-50 md:text-5xl">
            {slide.title}
          </h2>
          <p className="mt-2 text-sm text-background-200 md:text-base">{slide.subtitle}</p>
          <p className="mt-3 max-w-xl text-sm text-background-100/90 leading-relaxed line-clamp-2 md:line-clamp-3">
            {slide.desc}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${slide.comicId}`}
              className={`inline-flex items-center gap-2 rounded-md px-5 py-2.5 text-sm text-background-50 transition-colors whitespace-nowrap cursor-pointer ${slide.accent}`}
            >
              <i className="ri-book-read-line"></i>
              开始阅读
            </Link>
            <Link
              to="/category/全部"
              className="inline-flex items-center gap-2 rounded-md border border-background-50/50 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-background-50/10 whitespace-nowrap cursor-pointer"
            >
              浏览全部漫画
            </Link>
          </div>
        </div>

        <div className="absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2">
          {slides.map((s, idx) => (
            <button
              key={s.comicId}
              type="button"
              aria-label={`切换到 ${s.title}`}
              onClick={() => setCurrent(idx)}
              className={`h-2 rounded-full transition-all cursor-pointer ${
                idx === current ? "w-6 bg-primary-500" : "w-2 bg-background-50/60"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}